import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const GoogleSignIn = ({ onSuccess, onFailure, clientId }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    // Load Google Identity Services
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: (response) => {
            if (response.credential) {
              // Decode the JWT token to get user info
              const payload = JSON.parse(atob(response.credential.split('.')[1]));
              const userData = {
                profileObj: {
                  name: payload.name,
                  email: payload.email,
                  imageUrl: payload.picture,
                },
                tokenId: response.credential,
              };
              onSuccess(userData);
            } else {
              onFailure({ error: 'No credential received' });
            }
          },
          auto_select: false,
          cancel_on_tap_outside: true,
        });

        // Render the button
        if (buttonRef.current) {
          window.google.accounts.id.renderButton(buttonRef.current, {
            theme: 'outline',
            size: 'large',
            text: 'signin_with',
            shape: 'rectangular',
            locale: 'pt_BR',
          });
        }
      }
    };

    return () => {
      // Cleanup
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [clientId, onSuccess, onFailure]);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <div ref={buttonRef}></div>
    </div>
  );
};

GoogleSignIn.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
};

export default GoogleSignIn; 